import { useState } from "react";
import { Check, Sparkles } from "lucide-react";
import { usePromptGeneratorContext } from "@/components/feature/promptGenerator/hooks";
import { ACTION_BUTTON_STYLE } from "../constants";

interface Props {
  content: string;
  onImprovePrompt?: () => void;
}

export const ImproveButton = ({ content, onImprovePrompt }: Props) => {
  const { sendPromptToImprove } = usePromptGeneratorContext();
  const [isSent, setIsSent] = useState(false);

  const handleImprove = () => {
    if (!isSent) {
      setIsSent(true);
      onImprovePrompt?.();
      sendPromptToImprove(content);
    }
  };

  return (
    <button className={ACTION_BUTTON_STYLE} onClick={handleImprove}>
      {isSent ? <Check size={14} className="mr-1" /> : <Sparkles size={14} className="mr-1" />}
      {isSent ? "Sent" : "Improve"}
    </button>
  );
};
